import React, { useEffect, useState } from "react";

/* plugin */
import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
/* plugin end */

/* service */
import formService from "../../services/formService";
/* service end */

/* component */
import ErrorMsgComp from "../../components/ErrorMsgComp";
import InnerBgComp from "../../components/InnerBgComp";
import Header from "../../components/Header";
/* component end */

const SignInActiveLoan = () => {
  /* form */
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });
  /* form end */

  /* password function */
  const [eyeIcon, setEyeIcon] = useState(false);
  const togglePassword = () => {
    setEyeIcon(!eyeIcon);
  };
  /* password function end */

  useEffect(() => {
    /* form service */
    formService.inputEmptyCheck();
    /* form service end */
  }, []);

  return (
    <div>
      {/* Header Starts */}
      <Header loginBtn={true} />
      {/* Header Ends */}

      {/* Main Container Starts */}
      <div className="main-container">
        <InnerBgComp classes={"inner-bg-img"} />

        {/* start */}
        <div className="comm-rev">
          <div className="container">
            {/* form */}
            <motion.div
              initial={{ y: 60, scale: 0.8, opacity: 0 }}
              animate={{ y: 0, scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="form-box form-box-mt"
            >
              <div className="auth-hdn-box">
                <h2 className="auth-hdn">Sign in</h2>
                <div className="auth-para">
                  <p>
                    You already have an active loan to your account.{"\n"}
                    Please add your password to sign in.
                  </p>
                </div>
              </div>
              <form onSubmit={handleSubmit()}>
                <div className="form-grp-field">
                  <div className="form-grp int-padr">
                    <input
                      className="form-field"
                      type={eyeIcon ? "text" : "password"}
                      id="password"
                      name="password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                    />
                    <p className="form-label">Password</p>
                    <i
                      className={`view-pass ${
                        eyeIcon ? "icon-eye" : "icon-eye-slash"
                      }`}
                      onClick={() => togglePassword()}
                    ></i>
                  </div>
                  {errors.password && (
                    <ErrorMsgComp errorMessage={errors.password.message} />
                  )}
                </div>
                <div className="auth-para ap-txt-cen">
                  <b className="comm-link"> Forgot password? </b>
                </div>
                <button className="button button--block" type="submit">
                  <span>Sign In</span>
                </button>
              </form>
            </motion.div>
            {/* form end */}
          </div>
        </div>
        {/* end */}
      </div>
      {/* Main Container Ends */}
    </div>
  );
};

export default SignInActiveLoan;
